import { useMutation, useQuery } from "@tanstack/react-query";
import { TypedVehicle_tracking } from "./vehicle_tracking.query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';
import { TypedUser } from "interface/user.model";


export interface TypedVehicle {
    id?: string;
    name?: string;
    note?: string;
    license_plate?: string;
    vehicle_imei?: string;
    vehicle_status?: ENUM_VEHICLE_STATUS;
    createdAt?: string;
    endedAt?: string;
    vehicle_meta?: TypedVehicle_tracking;

    sum_of_income?: number; // tổng thu nhập
    sum_of_trip?: number; // tổng chi phí
    sum_of_distance?: number; // tổng KM

    default_driver_id?: string;

    default_driver_data?: TypedUser;

    sum?: {
        sum_of_log: number, // số chuyến
        sum_of_distance: number, // số chuyến
        sum_of_time: number, // số ngày tham gia
        sum_of_income: number,
    }

}

export enum ENUM_VEHICLE_STATUS {
    ACTIVE = 1,
    INACTIVE = 0,
}


type IQuery = TypedVehicle & IQueryParams;

export interface vehicleStat { vehicle_id: any; sum_of_income: number; sum_of_trip: number; sum_of_distance: number; }


/*
* List of all app
*/
export function useGetVehicles(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["vehicle/fetch_entity_list", object],
        queryFn: () => axios.get<TypedVehicle[]>(`/vehicle${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        refetchOnWindowFocus: true,
        refetchIntervalInBackground: true,
        refetchInterval: 30000,
        enabled: true,
    });
}



export function useGetVehicle(vehicle_id: string) {
    return useQuery({
        queryKey: ['vehicle/fetch_entity'],
        queryFn: () => axios.get<TypedVehicle>(`/vehicle/${vehicle_id}`).then((response) => response.data),
        retry: 1,
        // enabled: false,
    });
}


export function useMutateGetVehicles() {
    return useMutation({
        mutationKey: ['vehicle/fetch_entity_list'],
        mutationFn: (object: IQuery) => axios.get<TypedVehicle>(`/vehicle/${helpers.buildEndUrl(object)}`).then((response) => response.data),
    });
}

export function useMutateGetVehicle() {
    return useMutation({
        mutationKey: ['vehicle/fetch_entity'],
        mutationFn: (vehicle_id: any) => axios.get<TypedVehicle>(`/vehicle/${vehicle_id}`).then((response) => response.data),
    });
}


export function useUpdateVehicle() {
    return useMutation({
        mutationKey: ['vehicle/update_entity'],
        mutationFn: ({ id, ...rest }: TypedVehicle) => axios.patch<TypedVehicle>(`/vehicle/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity'] });
        }
    });
}


export function useMutateCreateVehicle() {
    return useMutation({
        mutationKey: ['vehicle/create_entity'],
        mutationFn: (entity: TypedVehicle) => axios.post<TypedVehicle>(`/vehicle`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity_list'] });
        }
    });
}

export function useMutateDeleteVehicle() {
    return useMutation({
        mutationKey: ['vehicle/delete_entity'],
        mutationFn: (id: any) => axios.delete<TypedVehicle>(`/vehicle/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity_list'] });
        }
    });
}